import clsx from 'clsx'

type HeadingProps = { level?: 1 | 2 | 3 | 4 | 5 | 6 } & React.ComponentPropsWithoutRef<
  'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
>

function hasAuditTextUtility(className: HeadingProps['className']) {
  return (
    typeof className === 'string' &&
    /\btext-(body(?:-lg|-sm)?|caption|mono|display-[\w-]+)\b/.test(className)
  )
}

export function Heading({ className, level = 1, ...props }: HeadingProps) {
  let Element: `h${typeof level}` = `h${level}`
  const usesAuditTextUtility = hasAuditTextUtility(className)

  return (
    <Element
      {...props}
      className={clsx(
        'font-semibold text-zinc-950 dark:text-white',
        !usesAuditTextUtility && 'text-2xl/8 sm:text-xl/8',
        className
      )}
    />
  )
}

export function Subheading({ className, level = 2, ...props }: HeadingProps) {
  let Element: `h${typeof level}` = `h${level}`
  const usesAuditTextUtility = hasAuditTextUtility(className)

  return (
    <Element
      {...props}
      className={clsx(
        'font-semibold text-zinc-950 dark:text-white',
        !usesAuditTextUtility && 'text-base/7 sm:text-sm/6',
        className
      )}
    />
  )
}
